<template>
  <transition
    appear
    appear-class="options-appear"
    appear-active-class="options-appear-active"
  >
    <div class="container app--link-list">
        <div
          class="app--link-item"
          v-for="lesson in results"
          :key="lesson.name"
        >
          <router-link :to="lesson.status ? lesson.link : '' " :class="lesson.class" :disabled="!lesson.status" >{{
            lesson.name
          }}</router-link>
        </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { apiHost } from "../services/config";

const API_URL = apiHost+"auth/";
export default {  
  data: function() {
    return {
      // Add a lesson object with name and link properties whenever a new lesson is created
      lessons: [
        { name: "Radioactivity", link: "/radioactivity" },
        { name: "Garden Beds", link: "/garden-beds" },
        { name: "Same Or Different", link: "/same-or-different" },
        { name: "Tackling Times Tables", link: "/times-tables" },
        { name: "Trigonometry Walk", link: "/trigonometry" },
        { name: "Truth Tiles 1", link: "/truth-tiles-1" },
        { name: "Truth Tiles 2", link: "/truth-tiles-2" },
        { name: "Take Away Tiles", link: "/take-away-tiles" },
        { name: "Steps", link: "/steps" },
        { name: "Number Tiles", link: "/number-tiles" },
        { name: "Chess Queens", link: "/chess-queens" },
        { name: "Eight Queens", link: "/eight-queens" },
        { name: "Crosses", link: "/crosses" },
        { name: "Angle Estimation", link: "/angle-estimation" },
        { name: "Area of a Triangle", link: "/area-of-triangle" },
        { name: "Biggest Volume", link: "/biggest-volume" },
        { name: "Ice-Cream Flavours", link: "/ice-cream-flavours" },
        { name: "Chances With Crosses", link: "/chances-with-crosses" },
        { name: "Fay's Nines", link: "/fays-nines" },
        { name: "Magic Squares", link: "/magic-squares" },
        { name: "Make a Million", link: "/make-a-million" },
        { name: "Sporting Finals (NRL)", link: "/sporting-finals-NRL" },
        { name: "Sporting Finals (AFL)", link: "/sporting-finals-AFL" },
        { name: "Dice Basketball", link: "/dice-basketball" },
        { name: "Dice Footy", link: "/dice-footy" },
        { name: "Counter Escape", link: "/counter-escape" },
        { name: "Building Views", link: "/building-views" },
        { name: "Problem Dice", link: "/problem-dice" },
        { name: "Crazy Animals", link: "/crazy-animals" },
        { name: "Cat and Mouse", link: "/cat-and-mouse" },
        { name: "Dice Cricket", link: "/dice-cricket" },
        { name: "Have A Hexagon", link: "/have-a-hexagon" },
        { name: "Walk The Plank", link: "/walk-the-plank" },
        { name: "Nine & Over", link: "/nine-and-over" },
        { name: "What’s It Worth?", link: "/whats-it-worth" },
        { name: "Doctor Dart", link: "/doctor-dart" },
        { name: "Dice Differences (Prisoners)", link: "/dice-differences" },
        { name: "2 Litre Balloon Problem", link: "/balloon" },
        { name: "Number Charts", link: "/number-charts" },
        { name: "Rectangle Fractions", link: "/rectangle-fractions" },
        { name: "Game Show", link: "/game-show" },
        { name: "Goldbach’s Conjecture", link: "/goldbachs-conjecture" },
        { name: "Addo", link: "/addo" },
        { name: "Birth Month Paradox", link: "/birth-month-paradox" },
        { name: "Algebra Charts", link: "/algebra-charts" },
        { name: "Multo: Better than Bingo", link: "/multo" },
        { name: "Bob’s Buttons", link: "/bobs-buttons" },
        { name: "Duelling Dice", link: "/duelling-dice" },
        { name: "Fractions & Fraction Charts", link: "/fraction-charts" },
        { name: "Natalie’s LCM Task", link: "/lcm" },
        { name: "Hunting For Stars", link: "/hunting-stars" },
        { name: "Cracked Tiles", link: "/cracked-tiles" },
        { name: "Billiard Ball Bounces", link: "/billiard-ball" },
        { name: "Palindromes", link: "/palindromes" },
        { name: "Chocolate Chip Cookies", link: "/chocolate-chip-cookies" },
        { name: "Beetle Game", link: "/beetle-game" },
        { name: "Chart Strategies", link: "/chart-strategies" },
        { name: "Goods & Bads", link: "/goods-and-bads" },
        { name: "Simple, Elegant, Elusive", link: "/simple-elegant-elusive" },
        { name: "Odds & Evens (Collatz Conjecture)", link: "/odds-and-evens" },
        { name: "Number Partitions (Ramanujan’s Problem)", link: "/number-partitions" },
        { name: "Cylinder Volumes", link: "/cylinder-volumes" },
        { name: "First Down the Mountain", link: "/first-down-mountain" },
        { name: "Heads & Legs", link: "/heads-and-legs" },
        { name: "Cars in a Garage", link: "/cars-in-a-garage" },
        { name: "What’s My Rule?", link: "/whats-my-rule" },
        { name: "Fraction Estimation", link: "/fraction-estimation" },
        { name: "Fractions to Decimals (on a rope!)", link: "/fractions-to-decimals" },
        { name: "Maths of Lotto", link: "/maths-of-lotto" },
        { name: "Protons & Anti-Protons", link: "/protons" },
        { name: "Game of 31", link: "/game-of-31" },
        { name: "Win At The Fair", link: "/win-at-the-fair" },
        { name: "Temperature Graphs", link: "/temperature-graphs" },
        { name: "Greedy Pig", link: "/greedy-pig" },
        { name: "Snakes & Ladders", link: "/snakes-and-ladders" },
        { name: "Square Pairs", link: "/square-pairs" },
        { name: "Highest Number", link: "/highest-number" },
        { name: "Division Boxes", link: "/division-boxes" },
        { name: "Making Selections", link: "/making-selections" },
        { name: "Spirolaterals", link: "/spirolaterals" },
        { name: "Knight’s Tour", link: "/knight-tour" },
      ],
      results : [],
    };
  },
  computed: {
    sortedLessons: function() {
      // Sort lessons on alphabetical order
      const sorted = this.lessons.slice().sort(function(l1, l2) {
        if (l1.name.toLowerCase() <= l2.name.toLowerCase()) return -1;
        else return 1;
      });
      return sorted;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    fetch() {
        axios.post(API_URL + "getLesson", { userId: this.$store.state.auth.user.id}, {
        headers: {
                'Content-Type': 'application/json; charset=UTF-8'
              }
      }).then((response) => {
        let data = response.data;
        const finalArray = [];
        this.lessons.forEach((e1) => {
          if(data.includes(e1.name)){
            finalArray.push({
              name : e1.name,
              link : e1.link,
              status : true,
              class: "btn btn-outline-success"
            })
          }else{
            finalArray.push({
              name : e1.name,
              link : e1.link,
              status : false,
              class: "btn btn-outline-success disabled-lesson"
            })
          }
        })
        const sortedArr = finalArray.slice().sort(function(l1, l2) {
          if (l1.name.toLowerCase() <= l2.name.toLowerCase()) return -1;
          else return 1;
        });
        this.results = sortedArr;
      })
    }
  },
  mounted() {
  this.fetch();
  }
};
</script>

<style scoped>
.app--link-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 1.5rem;
}
.app--link-item a {
  display: block;
}

.options-appear {
  opacity: 0;
}
.options-appear-active {
  transition: all 1s;
  transition-delay: 0.7s;
}
.disabled-lesson{
    background: aliceblue !important;
    cursor: not-allowed !important;
    opacity: 0.5 !important;
}
.disabled-lesson:hover{
    color: #28a745 !important;
    border-color: #28a745 !important;
}
</style>
